<!--

Simple text box for displaying text information. You can specify left, right, or
center positioning. Also, using default="false", you can specify colors. A 1em
margin is also optional for the top and bottom. Use "top", "bottom", or "both"
to apply a margin

Sample usage with defaults:
<text-box>words</text-box>

Sample usage with positions and colors:
<text-box
align="center"
default="false"
margin="top"
class="bg-blue-grey-7 text-red-1"
>
words 
</text-box>

-->

<template>
  <div>
    <div class="row copy" v-bind:class="[styles,positions,margins]">
    <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isCenter: false,
      isLeft: false,
      isRight: false,
      styles: {},
      margins: {}
    }
  },
  props: ['align','default', 'margin'],
  created: function() {
    this.alignText()
    this.setMargin()
    this.checkDefault()
  },
  computed: {
    positions: function() {
      return {
        'center-text': this.isCenter,
        'left-text': this.isLeft,
        'right-text': this.isRight,
      }
    }
  },
  methods: {
    alignText: function() {
      if (this.align == "center") {
          this.isLeft = false
          this.isRight = false
          this.isCenter = true
      } else if (this.align == "right") {
          this.isCenter = false
          this.isLeft = false
          this.isRight = true
      } else {
          this.isCenter = false
          this.isRight = false
          this.isLeft = true
      }
    },
    setMargin: function() {
      switch (this.margins) {
        case "top":
          this.margins = "top-margin"
        break

        case "bottom":
          this.margins = "bottom-margin"
        break

        case "both":
          this.margins = "both-margin"
        break
      }
    },
    defaultStyle: function() {
      return {
        'grey-text-theme01': true
      }
    },
    checkDefault: function() {
      if (!this.default) {
        this.styles = this.defaultStyle()
      }
    }
  }
}
</script>

<style scoped>
  .copy {
    display: block;
    width: 100%;
    line-height: 1.5em;
    padding: 1.0em;
  }

  .copy ul {
    -webkit-margin-before: 0.5em;
    -webkit-margin-after: 0;
    -webkit-margin-start: 0;
    -webkit-margin-end: 0;
    -webkit-padding-start: 1.0em;
  }

  .copy ul li {
    margin: 0;
  }

  .center-text {
    text-align: center;
  }

  .left-text {
    text-align: left;
  }

  .right-text {
    text-align: right;
  }

  .top-margin {
    margin-top: 1.0em;
  }

  .bottom-margin {
    margin-bottom: 1.0em;
  }

  .both-margin {
    margin-top: 1.0em;
    margin-bottom: 1.0em;
  }
</style>
